import type { UserLocalStorage } from '../../types/localStorage';

import { useCallback, useMemo } from 'react';
import useLocalStorageState from 'use-local-storage-state';

import {
  getDefaultPreferences,
  getUserPreferences,
} from './UISettings/uiSettings';

export const usePagePreferences = (page: string) => {
  const [userLS] = useLocalStorageState<UserLocalStorage>('cms.user');

  const viewPreferences = useMemo(() => getUserPreferences(userLS), [userLS]);

  return useCallback(
    (itemId: string) => {
      const defaultPreferences = getDefaultPreferences(userLS);
      if (!(page in viewPreferences) && !(page in defaultPreferences))
        return true;

      const pagePreferences =
        viewPreferences[page as keyof typeof viewPreferences] ||
        defaultPreferences[page as keyof typeof defaultPreferences];

      if (typeof pagePreferences !== 'object' || !(itemId in pagePreferences))
        return true;

      return pagePreferences[itemId as keyof typeof pagePreferences];
    },
    [page, userLS, viewPreferences],
  );
};
